import { Chart } from '@frontend/chart/types';

import { HOUR_DAY_HEATMAP_DAYS, HOUR_DAY_HEATMAP_HOURS } from '../../../../utils/to-hour-day-heatmap-series';

const rangeStart = new Date(Date.UTC(2026, 6, 27));

export const PUDO_TRANSACTION_TIMER_ACTIVITY_HOUR_DAY_HEATMAP_CHART_MOCK_DATA: Chart = {
    series: [
        {
            name: 'Activity',
            data: Array.from({ length: HOUR_DAY_HEATMAP_DAYS * HOUR_DAY_HEATMAP_HOURS }, (_, index) => {
                const dayIndex = Math.floor(index / HOUR_DAY_HEATMAP_HOURS);
                const hour = index % HOUR_DAY_HEATMAP_HOURS;
                const date = new Date(rangeStart);
                date.setUTCDate(rangeStart.getUTCDate() + dayIndex);
                date.setUTCHours(hour, 0, 0, 0);

                const weekdayBoost = dayIndex % 7 < 5 ? 1.4 : 0.5;
                const hourBoost = hour >= 8 && hour <= 18 ? 1.6 : 0.3;
                const value = Math.max(0, Math.round((3 + Math.sin(dayIndex / 2) * 2 + Math.cos(hour / 3) * 4) * weekdayBoost * hourBoost));

                return {
                    label: date.toISOString(),
                    value
                };
            })
        }
    ]
};
